import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import { CgMenuRightAlt } from "react-icons/cg";

import { useIntl } from '@edx/frontend-platform/i18n';
import messages from './messages'; // Import the messages file

import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import mainlogo from "./icons/main-logo.jpg";
import { getConfig } from '@edx/frontend-platform';
import { AppContext } from '@edx/frontend-platform/react';
import { useContext } from "react";

// Import white icons
import ApproveWhite from "./icons/ApproveWhite.png";
import EnrollmentWhite from "./icons/EnrollmentWhite.png";

// Import blue icons
import ApproveBlack from "./icons/ApproveBlack.png";
import EnrollmentBlack from "./icons/EnrollmentBlack.png";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { formatMessage } = useIntl();
  const location = useLocation();
  const dropdownRef = useRef(null);

  const { authenticatedUser, config } = useContext(AppContext);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const getIcon = (path, whiteIcon, blueIcon) => {
    return location.pathname === path ? whiteIcon : blueIcon;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="layout-container">
      <header className="header">
        <div className="main-header-logo">
          {/* Main logo now links directly to Studio base URL */}
          <a href={`${config.STUDIO_BASE_URL}/home`}>
             <img src={mainlogo} className="main-logo-img" alt="paniit-logo" />
          </a>
        </div>

        <div className="superadmin-dropdown" ref={dropdownRef}>
            <div className="dropdown-trigger" onClick={toggleDropdown}>
            {authenticatedUser ? authenticatedUser.username : "Super Admin"} {/* Replace static text with username */}
            {isDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
          </div>
          {isDropdownOpen && (
       <ul className="dropdown-menu">
       <li>
         <a href={`${getConfig().STUDIO_BASE_URL}/home`}>
           {formatMessage(messages.studioHome)}
         </a>
       </li>
       <li>
         <a href={`${getConfig().LMS_BASE_URL}/dashboard/`}>
           {formatMessage(messages.dashboard)}
         </a>
       </li>
       <li>
         <a href={`${getConfig().LMS_BASE_URL}/logout`}>
           {formatMessage(messages.signOut)}
         </a>
       </li>
     </ul>
          )}
        </div>
      </header>

      <section className="dashboard-content">
        <aside className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
          <CgMenuRightAlt className="toggle-icon" onClick={toggleSidebar} />

          {isSidebarOpen && (
            <ul>
              <div className="top-section">
                <img src={mainlogo} className="main-logo-sidebar" alt="logo" />
              </div>
              <h1>{formatMessage(messages.layoutMenu)}</h1>

              {/* Approvals link */}
              <Link to="/admin-panel/Approvals">
                <li className={location.pathname === "/admin-panel/Approvals" ? "active" : ""}>
                  <img
                    src={getIcon(
                      "/admin-panel/Approvals",
                      ApproveWhite,
                      ApproveBlack
                    )}
                    alt="Approvals Icon"
                    style={{ width: '40px', height: '40px' }} 
                  />
                  {formatMessage(messages.layoutApprovals)}
                </li>
              </Link>

              {/* Enrollments link */}
              <Link to="/admin-panel/Enrollments">
                <li className={location.pathname === "/admin-panel/Enrollments" ? "active" : ""}>
                  <img
                    src={getIcon(
                      "/admin-panel/Enrollments",
                      EnrollmentWhite,
                      EnrollmentBlack
                    )}
                    alt="Enrollments Icon"
                    style={{ width: '40px', height: '40px' }} 
                  />
                   {formatMessage(messages.layoutEnrollments)}
                </li>
              </Link>
            </ul>
          )}
        </aside>

        <main className="main-content">
          <Outlet />
        </main>
      </section>
    </div>
  );
};

export default Layout;
